import { SideColumn, SideCell } from 'components/time-entry-table'
import { TaskCell } from './cells/TaskCell'
import { DateTime } from 'luxon'

interface Props {
  taskIdsWithEntries: Set<number>
  hoverY: number
  tasks: SelectedTask[]
  start: DateTime
  end: DateTime
}

export function TaskNameColumn(props: Props) {
  return (
    <SideColumn side="left">
      {props.tasks.map((task, index) => (
        <SideCell
          key={`LeftColumnCell${task.id}`}
          rowIndex={index + 1}
          highlight={index + 1 == props.hoverY}
          testId="task-row"
        >
          <TaskCell
            taskIdsWithEntries={props.taskIdsWithEntries}
            key={`task_cell_${task.id}`}
            task={task}
            start={props.start}
            end={props.end}
          />
        </SideCell>
      ))}
    </SideColumn>
  )
}
